import React from "react";
import Analyse from "./component";

const AnalyseContainer = (props: any) => {
  return <Analyse {...props} />;
};

export default AnalyseContainer;
